import markupTemplating from "refractor/markup-templating";
export default markupTemplating;